// extracted by mini-css-extract-plugin
export default {"container":"ComboboxCoso_container__3E-eh","school":"ComboboxCoso_school__tHVos","logo":"ComboboxCoso_logo__pdTgh","name":"ComboboxCoso_name__kgQN2"};